import * as React from 'react';

const LogoBkc = (props) => (
  <svg fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M15.346 11.02c-5.797.225-7.949 5.855-9.854 4.763-1.192-.68-.494-3.542.398-5.87a34.125 34.125 0 0 0-4.113 6.056 13.217 13.217 0 0 0-1.01 9.024c.43 1.85 1.38 3.15 1.689 2.388a13.092 13.092 0 0 1 3.249-4.868s5.364 5.653 7.941 8.397c2.055 2.188 3.553 1.575 3.495.235-.06-1.357-1.769-6.716-3.164-14.785 2.546-1.48 5.377-2.884 11.528-5.436-1.077.232-6.429-.047-10.163.097'
      fill='#fff'
    />
    <path
      d='M26.31 6.594C23.655 5.988 18.944 5.65 13.145 6a9.243 9.243 0 0 1 1.302-4.85.615.615 0 0 0 .116-.288c0-.14-.234-.222-.577-.068a22.956 22.956 0 0 0-8.308 6.678c-1.288.464-3.755 1.552-3.755 1.552-.875.572-1.465 3.336-.598 5.574 3.052-5.29 6.67-7.453 6.67-7.453-1.406 3.4-2.315 5.763-1.677 6.402 1.366 1.366 2.664-2.145 6.484-2.985 2.24-.493 9.221-.079 12.022-.216 2.37-.114 3.42-.87 3.505-2.019.09-1.169-1.41-1.589-2.02-1.731'
      fill='#fff'
    />
  </svg>
);

export default LogoBkc;
